var GLSearch = {
  lastSearched: null,
  selected: {
    placeId: null,
    placeName: null,
    coordinates: {
      lat: null,
      lng: null,
    },
  },
};

GLSearch.getInput = function () {
  return jQuery('.location-search');
};

GLSearch.getForm = function () {
  return jQuery('.location-form');
};

GLSearch.getResultsList = function () {
  return jQuery('.location-search-results');
};

GLSearch.isSelected = function () {
  if (
    !GLSearch.selected.placeId &&
    (!GLSearch.selected.coordinates.lat || !GLSearch.selected.coordinates.lng)
  ) {
    return false;
  } else {
    return true;
  }
};

GLSearch.init = function () {
  GLSearch.getInput().on('blur', function () {
    setTimeout(function () {
      if (GLSearch.selected.placeName !== GLSearch.getInput().val()) {
        //if displayed locations is not the same as the saved one
        GLSearch.locationSelect();
      }
      GLSearch.removeResults();
    }, 200);
  });

  GLSearch.getInput().on('keydown', function (e) {
    if (e.which === 13) {
      //ENTER
      GLSearch.locationSelect();
      return;
    }

    if (e.which === 40) {
      //key down
      GLSearch.locationSelectDown();
      return;
    }

    if (e.which === 38) {
      //key up
      GLSearch.locationSelectUp();
      return;
    }

    GLSearch.search();

    //if(e.which === 27) {//key escape
    //  GLSearch.locationSelect();
    //}
  });

  jQuery(document).on('click', '.location-search-place', function (e) {
    e.preventDefault();
    var name = jQuery(this).find('a').html();
    var id = jQuery(this).attr('data-place-id');
    GLSearch.getInput().val(name);
    GLSearch.removeResults();
    GLSearch.selected.placeId = id;
    GLSearch.selected.placeName = name;
  });

  GLSearch.getForm().submit(function (e) {
    e.preventDefault();
  });

  jQuery('.location-search-submit').click(function () {
    var formEvent, eventDispatchedForm;
    if ('createEvent' in document) {
      formEvent = document.createEvent('HTMLEvents');
      formEvent.initEvent('custom-submit', false, true);
      eventDispatchedForm = GLSearch.getForm().get(0);
      if (eventDispatchedForm) {
        eventDispatchedForm.dispatchEvent(formEvent);
      }
    } else {
      // IE8
      formEvent = document.createEventObject();
      formEvent.eventType = 'custom-submit';
      eventDispatchedForm = GLSearch.getForm().get(0);
      if (eventDispatchedForm) {
        eventDispatchedForm.fireEvent('on' + formEvent.eventType, formEvent);
      }
    }
    if (GLSearch.selected.placeName) {
      GLSearch.addGATag(GLSearch.selected.placeName);
    }
  });
};

GLSearch.search = function () {
  var previousContent;

  setTimeout(function () {
    previousContent = GLSearch.getInput().val();
  }, 20);

  setTimeout(function () {
    var currentContent = GLSearch.getInput().val();
    if (
      previousContent === currentContent &&
      currentContent &&
      GLSearch.lastSearched !== currentContent
    ) {
      GLSearch.lastSearched = currentContent;
      //google api
      var autocompleteService = new google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions(
        {
          input: currentContent,
        },
        function listentoresult(list, status) {
          if (status === 'OK' && list !== null && list.length > 0) {
            GLSearch.printResults(list);
          } else {
            GLSearch.removeResults();
          }
        }
      );
    }
  }, 250);
};

GLSearch.printResults = function (list) {
  var ul = GLSearch.getResultsList();
  GLSearch.removeResults();
  for (var i = 0; i < list.length; i++) {
    ul.append(
      '<li class="location-search-place" data-place-id="' +
        list[i].place_id +
        '"><a href="#">' +
        list[i].description +
        '</a></li>'
    );
  }
};

GLSearch.removeResults = function () {
  GLSearch.getResultsList().empty();
};

GLSearch.locationSelect = function () {
  var selectedLocation = GLSearch.getResultsList().find(
    '.location-search-place.selected'
  );
  var first = GLSearch.getResultsList().find('.location-search-place:first');
  if (selectedLocation.length > 0) {
    //select selected in list
    selectedLocation.click();
  } else if (first.length > 0) {
    //select first in list
    first.click();
  } else if (GLSearch.getInput().val() === '') {
    GLSearch.selected.placeName = null;
    GLSearch.selected.placeId = null;
  } else if (GLSearch.selected.placeId) {
    GLSearch.getInput().val(GLSearch.selected.placeName);
    GLSearch.submit();
  } else if (GLSearch.isCoordinates()) {
    var coordinates = GLSearch.getInput().val().split(',');
    GLSearch.selected.coordinates.lat = parseFloat(coordinates[0].trim());
    GLSearch.selected.coordinates.lng = parseFloat(coordinates[1].trim());
  } else {
    GLSearch.getInput().val('');
  }
};

GLSearch.isCoordinates = function () {
  var val = GLSearch.getInput().val();
  var result = val.match(/[-+]?[0-9]*\.?[0-9]+, ?[-+]?[0-9]*\.?[0-9]+/);
  return result.length === 1;
};

GLSearch.locationSelectDown = function () {
  var selectedLocation = GLSearch.getResultsList().find(
    '.location-search-place.selected'
  );
  if (selectedLocation.length > 0) {
    //something is selected
    selectedLocation.removeClass('selected');
    if (selectedLocation.next('.location-search-place').length > 0) {
      //isnt last
      selectedLocation.next('.location-search-place').addClass('selected');
    } else {
      //is last
      GLSearch.getResultsList()
        .find('.location-search-place:first')
        .addClass('selected');
    }
  } else {
    //nothing is selected
    GLSearch.getResultsList()
      .find('.location-search-place:first')
      .addClass('selected');
  }
  var name = GLSearch.getResultsList()
    .find('.location-search-place.selected a')
    .html();
  GLSearch.getInput().val(name);
};

GLSearch.submit = function () {
  GLSearch.getInput().blur();
  jQuery('.location-search-submit').click();
};

GLSearch.addGATag = function (value) {
  if (typeof dataLayer !== 'undefined') {
    // GTM statistics event
    dataLayer.push({
      event: 'gaEvent',
      eventCategory: 'Cycling Trips',
      eventAction: 'Search',
      eventLabel: value,
    });
  }
};

GLSearch.locationSelectUp = function () {
  var selectedLocation = GLSearch.getResultsList().find(
    '.location-search-place.selected'
  );
  if (selectedLocation.length > 0) {
    //something is selected
    selectedLocation.removeClass('selected');
    if (selectedLocation.prev('.location-search-place').length > 0) {
      //isnt first
      selectedLocation.prev('.location-search-place').addClass('selected');
    } else {
      //is first
      GLSearch.getResultsList()
        .find('.location-search-place:last')
        .addClass('selected');
    }
  } else {
    //nothing is selected
    GLSearch.getResultsList()
      .find('.location-search-place:last')
      .addClass('selected');
  }
  var name = GLSearch.getResultsList()
    .find('.location-search-place.selected a')
    .html();
  GLSearch.getInput().val(name);
};

GLSearch.setCoordinates = function (lat, lng) {
  GLSearch.selected.coordinates.lat = lat;
  GLSearch.selected.coordinates.lng = lng;
  GLSearch.selected.placeId = null;
  GLSearch.selected.placeName = null;
  GLSearch.getInput().val(
    parseFloat(lat).toFixed(6) + ', ' + parseFloat(lng).toFixed(6)
  );
};
